import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { featureFlags } from '@repletoryreach/sdk-api';

export function useFeatureFlags(includeArchived = false) {
  return useQuery({
    queryKey: ['admin', 'feature-flags', { includeArchived }],
    queryFn: () => featureFlags.list({ include_archived: includeArchived })
  });
}

export function useUpsertFeatureFlag() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ key, ...req }: { key: string } & featureFlags.UpsertFeatureFlagRequest) =>
      featureFlags.upsert(key, req),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['admin', 'feature-flags'] })
  });
}

export function useDeleteFeatureFlag() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (key: string) => featureFlags.remove(key),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['admin', 'feature-flags'] })
  });
}

export function useUpsertOverride() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ key, ...req }: { key: string } & featureFlags.UpsertOverrideRequest) =>
      featureFlags.upsertOverride(key, req),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['admin', 'feature-flags'] })
  });
}

export function useDeleteOverride() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ key, id }: { key: string; id: string }) => featureFlags.deleteOverride(key, id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['admin', 'feature-flags'] })
  });
}
